import { DialogStore } from "./modules/DialogStore";
import { UserStore } from "./modules/UserStore";

export class RootStore {
  dialogStore: DialogStore = new DialogStore();
  userStore: UserStore = new UserStore();
}
